<div id="progressBar" class="loader">
  <div class="indeterminate"></div>
</div>
<router-outlet></router-outlet>
